import { useState, useEffect, useContext } from "react";
import "../../bookings-form.css";
import dayjs from "dayjs";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FloatingLabel from "react-bootstrap/FloatingLabel";
// import TimePicker from "react-time-picker";
// import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";

import "react-phone-input-2/lib/style.css";

import Accordion from "react-bootstrap/Accordion";
import Success_modal from "../../../common-section/Modals/Success_modal/Success_modal";
import { useForm, Controller, useWatch } from "react-hook-form";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { RegxExpression } from "../../../../utils/common";

import classNames from "classnames";
import useRazorpay from "react-razorpay";
import { getAdditionalSupport } from "../../../../utils/apis/master/Master";
import {
  postBooking,
  postCalculation,
} from "../../../../utils/apis/booking/booking";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { Modal, Spinner } from "react-bootstrap";
import { TimePicker } from "antd";
import Wallet_Payment_modal from "../../../common-section/Modals/Wallet_Payment_modal/Wallet_Payment_modal";
const Daily_form = ({ data }) => {
  const { IMG_URL, appSetup, userdata } = useContext(Context);

  console.log(data, "data data");

  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const formattedDate = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState();
  const [modalWalletShow, setModalWalleteShow] = useState();
  const [loading, setLoading] = useState();

  const [paymentType, setPaymentType] = useState();
  const [payment_percentage_id, set_payment_percentage_id] = useState();
  const [advance_amount, set_advance_amount] = useState();

  const [modalCount, setmodalCount] = useState(0);

  console.log("payment_percentage_id", payment_percentage_id, advance_amount);

  const [value, onChange] = useState("10:00");

  const [phoneValue, setPhoneValue] = useState("");
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
    watch,
    setValue,
  } = useForm();

  const watchStartDate = watch("start_date");
  const watchEndDate = watch("end_date");
  const watchStartTime = watch("start_time");
  const watchEndTime = watch("end_time");
  const watchHours = watch("hours");

  console.log("watchStartTime", watchStartTime, watchEndTime);

  const startTime = new Date(`1970-01-01T${watchStartTime}`);
  const formattedStartTime = startTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const [isCalculationDone, setIsCalculationDone] = useState(false);
  const [calculationError, setCalculationError] = useState(false);

  const [servicesId, setservicesId] = useState();
  // // Watch start_time and end_time fields

  const [useDays, setUseDays] = useState();
  console.log(calculationError, "calculationError");

  const [useRoundedHours, setRoundedHours] = useState();
  console.log(useRoundedHours, "useRoundedHours");

  useEffect(() => {
    if (watchStartDate) {
      setStartDate(new Date(watchStartDate));
    }
  }, [watchStartDate]);
  const [totalCharge, setTotalCharge] = useState(0);
  const [addOnCharge, setaddOnCharge] = useState(0);
  const [chargesError, setChargesError] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  console.log("addOnCharge", addOnCharge);
  const [details, setDetails] = useState({
    days: 0,
    base_price: 0,
    charges: {
      full_h_p: 0,
      full_h_c: 0,
      half_h_p: 0,
      half_h_c: 0,
      min_h_p: 0,
      min_h_c: 0,
    },
    platform_charge: 0,
    platform_charge_toshow: 0,
    gst: 0,
    start_time: "00:00:00",
    end_time: "00:00:00",
    hours: 0,
    total: 0,
    add_one_price: 0,
    free_h_p_discount: 0,
    no_of_pieces: 0,
    no_of_kilometer: 0,
  });

  const onSubmitCalculation = async (add_one_price = 0) => {
    setIsButtonDisabled(true);

    const f_data = {
      days: data?.open_24_hours == 1 ? 1 : getValues("days"),
      hours: useRoundedHours,
      service_id: data?.id,
      r_s_time: formattedStartTime,
      r_e_time: watchEndTime,
      start_date: new Date(getValues("start_date")).toISOString().split('T')[0],
      end_date: new Date(getValues("end_date")).toISOString().split('T')[0],
      add_one_price: addOnCharge,
      no_of_pieces: Number(getValues("no_of_pieces")),
      kilometer: Number(getValues("no_of_km")),
    };

    console.log("f_data", f_data);

    try {
      const res = await postCalculation(f_data);

      if (res?.success) {
        console.log("postCalculation", res);

        setCalculationError(false);
        setDetails(res.data);
        setValue("end_time", res?.data?.end_time);
        setValue("start_time", res?.data?.start_time);
        setValue("calculation_status", res?.success);
        setIsCalculationDone(true);
      } else {
        setCalculationError(res?.message);
      }
    } catch (error) {
      // Handle error
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const noofhours = useWatch({ control, name: "hours", defaultValue: 0 });

  useEffect(() => {
    setservicesId(data?.id);

    console.log(
      "watchStartDate",
      watchStartDate,
      watchEndDate,
      watchStartTime,
      watchEndTime
    );

    if (data?.service_type_id !== 3) {
      if (watchStartDate && watchEndDate && watchStartTime && watchEndTime) {
        const startDate = new Date(watchStartDate);
        const endDate = new Date(watchEndDate);
        const startTime = new Date(`1970-01-01T${watchStartTime}`);
        const formattedStartTime = startTime.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        });
        const endTime = new Date(`1970-01-01T${watchEndTime}`);
        const formattedEndTime = endTime.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        });

        const days = Math.ceil(
          (endDate - startDate) / (1000 * 60 * 60 * 24) + 1
        );
        setUseDays(days);

        setValue("days", days);
        function parseTimeToMilliseconds(timeStr) {
          const [hours, minutes] = timeStr.split(":").map(Number);
          return (hours * 60 + minutes) * 60 * 1000; // Convert to milliseconds
        }

        const formattedStartTimenow = formattedStartTime;
        const formattedEndTimenow = formattedEndTime;

        const startTimeMs = parseTimeToMilliseconds(formattedStartTimenow);
        const endTimeMs = parseTimeToMilliseconds(formattedEndTimenow);

        const hours = Math.max((endTimeMs - startTimeMs) / (1000 * 60 * 60), 0);
        const roundedHours = Math.ceil(hours);

        setRoundedHours(roundedHours);

        if (days === 1) {
          if (formattedStartTime < data?.full_d_start_time) {
            console.log("Studio Not Started Yet");
            setChargesError("Studio Not Started Yet");
            return;
          }
          if (formattedStartTime < data?.full_d_start_time) {
            console.log("Studio Not Started Yet");
            setChargesError("Studio Not Started Yet");
            return;
          }

          if (formattedEndTime > data?.full_d_end_time) {
            console.log("Studio Closed after This Time");
            setChargesError("Studio Closed after This Time");
            return;
          }

          if (roundedHours < data?.minimum_hours) {
            console.log("Not Eligible");
            setChargesError("Not Eligible: Please Increase Your Time");
            return;
          }

          if (roundedHours > data?.full_day_hours) {
            console.log("Working Hour Is Over");
            setChargesError("Working Hour Is Over");
            return;
          }

          // Handle exact match for half-day hours
          if (roundedHours === data?.service_charge?.half_day_hours) {
            console.log("You are at half day hours");
            // setChargesError(`Price Money is ${ data?.service_charge?.half_day_charges}`);
            setTotalCharge(data?.service_charge?.half_day_charges);
            return;
          }

          // Handle exact match for full-day hours
          if (roundedHours === data?.full_day_hours) {
            console.log("You are at full day hours");
            // setChargesError(`Price Money is ${ data?.service_charge?.full_day_charges}`);
            setTotalCharge(data?.service_charge?.full_day_charges);
            return;
          }

          // Handle the range between half-day and full-day hours
          if (
            roundedHours > data?.service_charge?.half_day_hours &&
            roundedHours < data?.full_day_hours
          ) {
            const price =
              data?.service_charge?.half_day_charges +
              data?.service_charge?.hourly_basis_charges *
              (roundedHours - data?.service_charge?.half_day_hours);
            console.log("You are between half day and full day");
            // setChargesError(`Your Price Money is ${price}`);
            setTotalCharge(price);
            return;
          }

          // Handle range between minimum and half-day hours
          if (
            roundedHours > data?.minimum_hours &&
            roundedHours < data?.service_charge?.half_day_hours
          ) {
            const price =
              data?.service_charge?.hourly_basis_charges * roundedHours;
            console.log("You are between minimum and half day hours");
            // setChargesError(`Price Money is ${price}`);
            setTotalCharge(price);
          }

          if (roundedHours == data?.minimum_hours) {
            const price =
              data?.service_charge?.hourly_basis_charges * roundedHours;
            console.log("You are between minimum and half day hours");
            // setChargesError(`Price Money is ${price}`);
            setTotalCharge(price);
          }

          setChargesError("");
        }

        if (days > 1) {
          if (formattedStartTime < data?.full_d_start_time) {
            console.log("Studio Not Started Yet");
            setChargesError("Studio Not Started Yet");
            return;
          }

          if (formattedEndTime > data?.full_d_end_time) {
            console.log("Studio Closed after This Time");
            setChargesError("Studio Closed after This Time");
            return;
          }

          if (roundedHours < data?.minimum_hours) {
            console.log("Not Eligible");
            setChargesError("Not Eligible: Please Increase Your Time");
            return;
          }

          if (roundedHours > data?.full_day_hours) {
            console.log("Working Hour Is Over");
            setChargesError("Working Hour Is Over");
            return;
          }

          // Handle exact match for half-day hours
          if (roundedHours === data?.service_charge?.half_day_hours) {
            console.log("You are at half day hours");
            // setChargesError(`Price Money is ${ data?.service_charge?.half_day_charges}`);
            setTotalCharge(data?.service_charge?.half_day_charges * days);
            return;
          }

          // Handle exact match for full-day hours
          if (roundedHours === data?.full_day_hours) {
            console.log("You are at full day hours");
            // setChargesError(`Price Money is ${ data?.service_charge?.full_day_charges}`);
            setTotalCharge(data?.service_charge?.full_day_charges * days);
            return;
          }

          // Handle the range between half-day and full-day hours
          if (
            roundedHours > data?.service_charge?.half_day_hours &&
            roundedHours < data?.full_day_hours
          ) {
            const price =
              data?.service_charge?.half_day_charges +
              data?.service_charge?.hourly_basis_charges *
              (roundedHours - data?.service_charge?.half_day_hours);
            console.log("You are between half day and full day");
            // setChargesError(`Your Price Money is ${price}`);
            setTotalCharge(price * days);
            return;
          }

          // Handle range between minimum and half-day hours
          if (
            roundedHours > data?.minimum_hours &&
            roundedHours < data?.service_charge?.half_day_hours
          ) {
            const price =
              data?.service_charge?.hourly_basis_charges * roundedHours;
            console.log("You are between minimum and half day hours");
            // setChargesError(`Price Money is ${price}`);
            setTotalCharge(price * days);
          }

          if (roundedHours == data?.minimum_hours) {
            const price =
              data?.service_charge?.hourly_basis_charges * roundedHours;
            console.log("You are between minimum and half day hours");
            // setChargesError(`Price Money is ${price}`);
            setTotalCharge(price * days);
          }
          setChargesError("");
        }

        // Calculate charges
        // const dayCharges = days *  data?.service_charge?.full_day_charges;
        // const hourCharges = TimeDifference *  data?.service_charge?.hourly_basis_charges;

        // setTotalCharge(dayCharges + hourCharges);
      }
    } else {
      // Calculate days based on noofhours
      const days = Math.ceil(noofhours / 24); // Complete days

      // Log for debugging
      console.log("days", noofhours, days);

      // Set days; ensure it defaults to at least 1 day if noofhours < 24
      setValue("days", days >= 1 ? days : 1);

      // Parse start_time to calculate the end_time
      const startDateTime = dayjs(`1970-01-01T${watchStartTime}`); // Default date added for context

      // Add the hours to start time
      const endDateTime = startDateTime.add(noofhours, "hour");

      // Format the calculated end time as HH:mm:ss
      const formattedEndTime = endDateTime.format("HH:mm:ss");

      console.log(
        "startDateTime",
        startDateTime,
        endDateTime,
        formattedEndTime
      );

      setValue("end_time", formattedEndTime);

      // Log the results
      console.log("Calculated days:", days >= 1 ? days : 1);
      console.log("End time:", formattedEndTime);

      // Update rounded hours
      setRoundedHours(noofhours);
    }
  }, [watchStartDate, watchEndDate, watchStartTime, watchEndTime, noofhours]);

  const selectedAddOns = watch("add_on_id");

  console.log(selectedAddOns, "selectedAddOns");

  const handleCheckboxChange = (id, checked, rate) => {
    const currentAddOns = selectedAddOns || [];
    console.log(checked, "checked");

    if (checked) {
      setValue("add_on_id", [...currentAddOns, id]);
      // setTotalCharge(totalCharge);
      setaddOnCharge((prevCharge) => prevCharge + Number(rate));
    } else {
      setValue(
        "add_on_id",
        currentAddOns.filter((itemId) => itemId !== id)
      );
      setaddOnCharge((prevCharge) => prevCharge - Number(rate));
    }
  };

  console.log("add_on_id", getValues("add_on_id"));

  const selectedsupport = watch("additional_support_id");

  const handleCheckboxChangeSupport = (id, checked) => {
    const currentAddOns = selectedsupport || [];
    if (checked) {
      setValue("additional_support_id", [...currentAddOns, id]);
    } else {
      setValue(
        "additional_support_id",
        currentAddOns.filter((itemId) => itemId !== id)
      );
    }
  };

  const [dataSupport, setDataSupport] = useState();
  const getAllData = async () => {
    const res = await getAdditionalSupport();
    if (res?.success) {
      setDataSupport(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  console.log("dataSupport", dataSupport, data);

  useEffect(() => {
    getAllData();
  }, []);

  useEffect(() => { }, []);

  const [Razorpay, openRazorpay] = useRazorpay();
  const [razorid, setRazorId] = useState();

  const onSubmit = (datafinal) => {
    console.log("datafinal", datafinal);
    setModalWalleteShow(false);

    const selectedStartDate = new Date(datafinal.start_date)
      .toISOString()
      .split("T")[0];

    const selectedEndDate = new Date(datafinal.end_date)
      .toISOString()
      .split("T")[0];
    const { start_time, end_time } = datafinal;
    // datafinal?.days = datafinal;

    // Check for booking conflicts

    const isBooked = data?.book_studios?.some((booking) => {
      const bookingStartDate = new Date(booking.start_date)
        .toISOString()
        .split("T")[0];

      const bookingEndDate = new Date(booking.end_date)
        .toISOString()
        .split("T")[0];
      const bookingDate = new Date(booking.date).toISOString().split("T")[0];

      // Check if selected date range overlaps with booking date range
      const isDateOverlap =
        (selectedStartDate >= bookingStartDate &&
          selectedStartDate <= bookingEndDate) ||
        (selectedEndDate >= bookingStartDate &&
          selectedEndDate <= bookingEndDate) ||
        (bookingStartDate >= selectedStartDate &&
          bookingStartDate <= selectedEndDate) ||
        (bookingEndDate >= selectedStartDate &&
          bookingEndDate <= selectedEndDate) ||
        selectedStartDate === bookingDate ||
        selectedEndDate === bookingDate;

      const isTimeOverlap =
        (start_time >= booking.start_time && start_time < booking.end_time) ||
        (end_time > booking.start_time && end_time <= booking.end_time) ||
        (start_time <= booking.start_time && end_time >= booking.end_time);

      return isDateOverlap && isTimeOverlap;
    });

    // setError(chargesError);

    if (isBooked || chargesError) {
      if (chargesError !== 0) {
        console.log(chargesError);
      }
      if (isBooked) {
        setError("end_time", {
          type: "manual",
          message:
            "This time slot is already booked within the selected date range.",
        });
      }
    } else {
      clearErrors("end_time");
      if (paymentType === "wallet") {
        finalFunction(datafinal);
      } else {
        handleRazorpay(datafinal);
      }

      // finalFunction(datafinal);
      console.log("Form submitted successfully");
    }
  };

  const handleRazorpay = async (data) => {
    const options: RazorpayOptions = {
      key: "rzp_test_I05KCFb1v5JJRc",
      // amount: Math.round(totalCharge + appSetup?.platform_charges) * 100,
      amount:
        (advance_amount ? advance_amount : Math.round(details?.total)) * 100,
      currency: "INR",
      name: "ShubhaRambh",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(data, res.razorpay_payment_id);
       
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const [isLoading, setIsLoading] = useState(false);

  // const [error, setError] = useState(0);
  const finalFunction = async (data, payment_id) => {
    setIsLoading(true);

    console.log("finalFunction", data);

    try {
      const selectedStartDate = new Date(data.start_date)
        .toISOString()
        .split("T")[0];

      const selectedEndDate = new Date(data.end_date)
        .toISOString()
        .split("T")[0];

      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];

      const datafinal = {
        service_id: servicesId,
        type: "Daily",
        start_time: data?.start_time,
        end_time: data?.end_time,
        start_date: selectedStartDate,

        end_date: selectedEndDate,
        date: formattedDate,
        name: data?.name,
        // amount: totalCharge + appSetup?.platform_charges,
        amount: details?.total,
        // payment_id: payment_id,
        payment_id: 1234,
        contact_no: data?.contact_no,
        days: data?.days,
        add_on_id: data?.add_on_id,
        additional_support_id: data?.additional_support_id,
        support_description: data?.support_description,
        base_price: details?.base_price,
        add_on_price: details?.add_one_price,
        gst_percentage: Number(details?.gst),
        gst_charge: Number(details?.gstchargestoshow),
        platfrom_percentage: Number(details?.platform_charge),
        platform_charges: details?.platform_charge_toshow,
        no_of_pieces: Number(getValues("no_of_pieces")),
        no_of_kilometer: Number(getValues("no_of_km")),
        hours: useRoundedHours,
        payment_type: paymentType,
        payment_percentage_id: payment_percentage_id,
        advance_amount: paymentType === "online" ? advance_amount : details?.total,
      };

      if (data?.email) {
        datafinal.email = data?.email;
      }

      if (data?.description) {
        datafinal.description = data?.description;
      }

      console.log("datafinal", datafinal);

      const res = await postBooking(datafinal);
      if (res?.success) {
        reset();
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate("/"); // This will navigate to the home page
        }, 3000);
      } else {
        setError("message", res?.message);
      }
    } catch (error) {
      console.error("Error in finalFunction:", error);
    } finally {
      setIsLoading(false); // Hide spinner
    }
  };

  const loaderDiv = () => (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter "
      centered
      className="spinner_modal"
      show={true} // Control visibility with local state
    >
      <Modal.Body>
        <Spinner animation="grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Modal.Body>
    </Modal>
  );

  const errorStyle = {
    color: "red",
    fontSize: "14px",
    margin: "10px 0",
  };

  console.log("errors", errors);

  console.log("userdata", userdata, details);

  return (
    <>
      <div className="booking-from-sec">
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="form-bg">
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="form-group">
                    <Form.Label>Start Date</Form.Label>

                    {/* <input
                      min={new Date().toISOString().split("T")[0]}
                      type="date"
                      className="form-control"
                      placeholder="from"
                      value={startDate}
                      {...register("start_date", { required: "Start Date is required" })} 
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                      onInput={(e) => {
                        const inputValue = e.target.value;
                        const [year, month, day] =
                          inputValue.split("-");
                        if (year && year.length > 4) {
                          e.target.value = `${year.slice(0, 4)}-${month || ""
                            }-${day || ""}`.replace(/-+$/, "");
                        }
                      }}
                    /> */}

                    <Controller
                      name="start_date"
                      rules={{
                        required: "Start Date is required",
                      }}
                      control={control}
                      defaultValue={new Date()}
                      render={({ field }) => (
                        <DatePicker
                          selected={field.value}
                          onChange={(date) => {
                            field.onChange(date);
                            setIsCalculationDone(false);
                          }}
                          onChangeRaw={(e) => {
                            let inputValue = e?.target?.value?.replace(/\D/g, ""); // Remove non-numeric
                            if (inputValue?.length > 8) inputValue = inputValue?.slice(0, 8); // Restrict length

                            if (inputValue?.length === 8) {
                              const formattedDate = `${inputValue?.slice(0, 2)}/${inputValue?.slice(
                                2,
                                4
                              )}/${inputValue?.slice(4, 8)}`;
                              e.target.value = formattedDate;
                            }
                          }}
                          autoComplete="off"
                          className={classNames("form-control", {
                            "is-invalid": errors?.end_date,
                          })}
                          placeholderText="MM/DD/YYYY"
                          minDate={new Date()}
                        />
                      )}
                    />
                    {errors?.start_date && (
                      <span className="invalid-feedback  d-block">
                        {errors.start_date.message}
                      </span>
                    )}
                  </div>
                </div>

                {data?.service_type_id !== 3 ? (
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <Form.Label>End Date</Form.Label>

                      {isLoading && loaderDiv()}
                      <Controller
                        rules={{
                          required: "End Date is required",
                        }}
                        name="end_date"
                        control={control}
                        defaultValue={new Date()}
                        render={({ field }) => (
                          <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                              field.onChange(date);
                              setIsCalculationDone(false);
                            }}
                            autoComplete="off"
                            className={classNames("form-control", {
                              "is-invalid": errors?.end_date,
                            })}
                            onChangeRaw={(e) => {
                              let inputValue = e?.target?.value?.replace(/\D/g, ""); // Remove non-numeric
                              if (inputValue?.length > 8) inputValue = inputValue?.slice(0, 8); // Restrict length

                              if (inputValue?.length === 8) {
                                const formattedDate = `${inputValue?.slice(0, 2)}/${inputValue?.slice(
                                  2,
                                  4
                                )}/${inputValue?.slice(4, 8)}`;
                                e.target.value = formattedDate;
                              }
                            }}
                            placeholderText="MM/DD/YYYY"
                            minDate={startDate}
                          />
                        )}
                      />
                      {errors?.end_date && (
                        <span className="invalid-feedback  d-block">
                          {errors.end_date.message}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}

                <div className="col-lg-3 col-md-6 ">
                  <div className="form-group">
                    <Form.Label>Start Time</Form.Label>

                    <Controller
                      name="start_time"
                      control={control}
                      rules={{
                        required: "Start time is required",
                        validate: (value) => {
                          // You can add additional validation if needed
                          return true; // Pass validation if no issues
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <div>
                          <TimePicker
                            use12Hours
                            format="h:mm a"
                            className={`form-control ${error ? "is-invalid" : ""
                              }`} // Add error styling
                            value={
                              field.value ? dayjs(field.value, "HH:mm") : null
                            } // Ensure value is a Day.js object
                            onChange={(time) => {
                              console.log("Raw Day.js time selected:", time); // Logs raw Day.js object
                              if (time) {
                                // Convert Day.js object to HH:mm format string
                                const formattedTime = time.format("HH:mm");
                                setValue("start_time", `${formattedTime}:00`);
                                setChargesError("");
                                setIsCalculationDone(false);
                                console.log("Formatted time:", formattedTime);

                                // Update the form value
                                field.onChange(formattedTime);
                              } else {
                                // Handle cleared value
                                setValue("start_time", "");
                                field.onChange("");
                              }
                            }}
                            disabledHours={() => {
                              const currentTime = dayjs(); // Current time
                              const selectedDate = dayjs(
                                getValues("start_date")
                              ); // Get selected start_date
                              const isToday = selectedDate.isSame(
                                dayjs(),
                                "day"
                              ); // Check if the selected date is today

                              if (isToday) {
                                // Disable past hours for today
                                const disabledHours = [];
                                for (let i = 0; i < 24; i++) {
                                  if (currentTime.hour() > i) {
                                    disabledHours.push(i); // Disable past hours
                                  }
                                }
                                return disabledHours; // Return the list of disabled hours
                              }
                              return []; // No disabled hours if not today (can select any hour)
                            }}
                            disabledMinutes={(hour) => {
                              const currentTime = dayjs(); // Current time
                              const selectedDate = dayjs(
                                getValues("start_date")
                              ); // Get selected start_date
                              const isToday = selectedDate.isSame(
                                dayjs(),
                                "day"
                              ); // Check if the selected date is today

                              if (isToday && currentTime.hour() === hour) {
                                // If the selected hour is the current hour, disable past minutes
                                const currentMinute = currentTime.minute(); // Get current minutes
                                const disabledMinutes = [];
                                for (let i = 0; i < 60; i++) {
                                  if (i < currentMinute) {
                                    disabledMinutes.push(i); // Disable past minutes for the current hour
                                  }
                                }
                                return disabledMinutes; // Return the list of disabled minutes for the current hour
                              }
                              return []; // No disabled minutes if not the current hour
                            }}
                          />
                          {error && (
                            <div className="invalid-feedback">
                              {error.message}
                            </div>
                          )}{" "}
                          {/* Display validation error */}
                        </div>
                      )}
                    />
                  </div>
                </div>

                {data?.service_type_id === 3 ? (
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <Form.Label>Hours</Form.Label>
                      <Controller
                        name="hours"
                        control={control}
                        rules={{
                          required: "Hours are required",
                          min: { value: 1, message: "Give Positive Value" }, // Ensures positive values only
                        }}
                        render={({ field }) => (
                          <Form.Control
                            type="number"
                            name="hours"
                            placeholder="Enter Hours"
                            value={field.value || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseFloat(value);

                              if (parsedValue >= 1 || value === "") {
                                // Only allow positive numbers or clear the field
                                setValue("hours", parsedValue || ""); // Update the value in the form state
                                field.onChange(parsedValue || ""); // Update react-hook-form field value
                              } else {
                                // If invalid, clear the input or leave it unchanged
                                console.error(
                                  "Negative values are not allowed."
                                );
                              }

                              setValue("calculation_status", false);
                              setIsCalculationDone(false); // Reset calculation flag
                            }}
                            className={classNames("", {
                              "is-invalid": errors?.hours,
                              "is-valid": !errors?.hours && getValues("hours"),
                            })}
                          />
                        )}
                      />

                      {errors?.hours && (
                        <span className="invalid-feedback">
                          {errors.hours.message}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}

                {data?.service_type_id !== 3 ? (
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <Form.Label>End Time</Form.Label>

                      <Controller
                        name="end_time"
                        control={control}
                        rules={{
                          required: "End time is required",
                          validate: (value) => {
                            const startTime = getValues("start_time");
                            const startDate = getValues("start_date"); // Get the start date
                            const endTime = value;
                            const endDate = getValues("end_date"); // Get the end date

                            // If start_time, end_time or start_date are not available, return true to allow the field to be filled
                            if (
                              !startTime ||
                              !startDate ||
                              !endTime ||
                              !endDate
                            ) {
                              return true;
                            }

                            // Parse start_time, end_time, and start_date to dayjs objects
                            const startTimeParsed = dayjs(startTime, "HH:mm");
                            const endTimeParsed = dayjs(endTime, "HH:mm");
                            const startDateParsed = dayjs(startDate);
                            const endDateParsed = dayjs(endDate);

                            // If start_date and end_date are the same day, ensure end_time is not earlier than start_time
                            if (
                              startDateParsed.isSame(endDateParsed, "day") &&
                              endTimeParsed.isBefore(startTimeParsed)
                            ) {
                              return "End time cannot be earlier than start time"; // Custom error message
                            }

                            return true; // Pass validation
                          },
                        }}
                        render={({ field, fieldState: { error } }) => (
                          <div>
                            <TimePicker
                              use12Hours
                              format="h:mm a"
                              className={`form-control ${error ? "is-invalid" : ""
                                }`} // Add error styling
                              value={
                                field.value ? dayjs(field.value, "HH:mm") : null
                              } // Ensure value is a Day.js object
                              onChange={(time) => {
                                if (time) {
                                  // Convert Day.js object to HH:mm format string
                                  const formattedTime = time.format("HH:mm");
                                  setValue("end_time", `${formattedTime}:00`);
                                  setChargesError("");
                                  setIsCalculationDone(false);
                                  field.onChange(formattedTime);
                                } else {
                                  // Handle cleared value
                                  setValue("end_time", "");
                                  field.onChange("");
                                }
                              }}
                              disabledHours={() => {
                                const startTime = getValues("start_time");
                                const startDate = getValues("start_date");
                                const endDate = getValues("end_date");

                                const startTimeParsed = dayjs(
                                  startTime,
                                  "HH:mm"
                                );
                                const startDateParsed = dayjs(startDate);
                                const endDateParsed = dayjs(endDate);

                                // If end_date is tomorrow or later, allow all hours, otherwise disable past hours based on start_time
                                if (
                                  endDateParsed.isAfter(startDateParsed, "day")
                                ) {
                                  return []; // No hours are disabled if end_date is tomorrow or later
                                }

                                // Disable hours before the start_time if the start_date and end_date are the same day
                                const disabledHours = [];
                                for (let i = 0; i < 24; i++) {
                                  if (startTimeParsed.hour() > i) {
                                    disabledHours.push(i);
                                  }
                                }
                                return disabledHours;
                              }}
                              disabledMinutes={(hour) => {
                                const startTime = getValues("start_time");
                                const startDate = getValues("start_date");
                                const endDate = getValues("end_date");

                                const startTimeParsed = dayjs(
                                  startTime,
                                  "HH:mm"
                                );
                                const startDateParsed = dayjs(startDate);
                                const endDateParsed = dayjs(endDate);

                                // If end_date is tomorrow or later, allow all minutes
                                if (
                                  endDateParsed.isAfter(startDateParsed, "day")
                                ) {
                                  return []; // No minutes are disabled if end_date is tomorrow or later
                                }

                                // Disable minutes if the selected hour is the same as the start_time hour
                                if (
                                  startDateParsed.isSame(
                                    endDateParsed,
                                    "day"
                                  ) &&
                                  hour === startTimeParsed.hour()
                                ) {
                                  const disabledMinutes = [];
                                  const currentMinutes = startTimeParsed.minute();
                                  for (let i = 0; i < 60; i++) {
                                    if (i < currentMinutes) {
                                      disabledMinutes.push(i); // Disable minutes before the start_time minute
                                    }
                                  }
                                  return disabledMinutes;
                                }
                                return [];
                              }}
                            />
                            {error && (
                              <div className="invalid-feedback">
                                {error.message}
                              </div>
                            )}{" "}
                            {/* Display validation error */}
                          </div>
                        )}
                      />

                      {/* <Controller
                        name="end_time"
                        control={control}
                        // defaultValue="00:00"
                        render={({ field }) => (
                          <TimePicker
                            className="form-control"
                            onChange={(time) => {
                              field.onChange(time);


                              if (time) {
                                setValue("end_time", `${time}:00`); // Update the form value
                                setChargesError("");
                                setIsCalculationDone(false);
                              } else {
                                // If the time is cleared, reset the value or handle as needed
                                setValue("end_time", "");
                              }



                            }}
                            value={field.value}
                            disableClock={true}
                          // clearIcon={null}
                          />
                        )}
                      />
                      {errors.end_time && (
                        <div className="text-danger">
                          {errors.end_time.message}
                        </div>
                      )} */}
                    </div>
                    {chargesError && (
                      <div style={errorStyle}>{chargesError}</div>
                    )}
                  </div>
                ) : null}

                {data?.service_type_id === 6 ? (
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <Form.Label>No. of Pieces</Form.Label>
                      <Controller
                        name="no_of_pieces"
                        control={control}
                        rules={{
                          required: "No. of Pieces is required",
                          min: {
                            value: 1,
                            message: "No. of Pieces must be at least 1",
                          }, // Ensures positive value
                        }}
                        render={({ field }) => (
                          <Form.Control
                            type="number"
                            name="no_of_pieces"
                            placeholder="Enter No. of Pieces"
                            value={field.value || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseFloat(value);

                              if (parsedValue >= 1 || value === "") {
                                // Only allow positive numbers or clear the field
                                field.onChange(parsedValue || ""); // Update field with valid value
                                setValue("no_of_pieces", parsedValue || "");
                              }
                              setIsCalculationDone(false); // Reset calculation flag
                            }}
                            className={classNames("", {
                              "is-invalid": errors?.no_of_pieces,
                              "is-valid":
                                !errors?.no_of_pieces &&
                                getValues("no_of_pieces"),
                            })}
                          />
                        )}
                      />

                      {errors?.no_of_pieces && (
                        <span className="invalid-feedback">
                          {errors.no_of_pieces.message}
                        </span>
                      )}
                    </div>

                    {chargesError && (
                      <div style={errorStyle}>{chargesError}</div>
                    )}
                  </div>
                ) : null}

                {data?.service_type_id === 7 ? (
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <Form.Label>No. of Kilometer</Form.Label>
                      <Controller
                        name="no_of_km"
                        control={control}
                        rules={{
                          required: "No. of Kilometer is required",
                          min: {
                            value: 1,
                            message: "No. of Kilometer must be at least 1",
                          }, // Ensures positive value
                        }}
                        render={({ field }) => (
                          <Form.Control
                            type="number"
                            name="no_of_km"
                            placeholder="Enter No. of Kilometer"
                            value={field.value || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseFloat(value);

                              if (parsedValue >= 1 || value === "") {
                                // Only allow positive numbers or clear the field
                                field.onChange(parsedValue || ""); // Update field with valid value
                                setValue("no_of_km", parsedValue || "");
                              }
                              setIsCalculationDone(false); // Reset calculation flag
                            }}
                            className={classNames("", {
                              "is-invalid": errors?.no_of_km,
                              "is-valid":
                                !errors?.no_of_km && getValues("no_of_km"),
                            })}
                          />
                        )}
                      />

                      {errors?.no_of_pieces && (
                        <span className="invalid-feedback">
                          {errors.no_of_pieces.message}
                        </span>
                      )}
                    </div>

                    {chargesError && (
                      <div style={errorStyle}>{chargesError}</div>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* <div className="col-lg-11 mx-auto mt-5">
            <div className="form-bg">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <Form.Label>Whole day Charges:</Form.Label>
                    <p className="charges-text-holder">
                      { data?.service_charge?.full_day_charges}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <Form.Label>Half day Charges:</Form.Label>
                    <p className="charges-text-holder">
                      { data?.service_charge?.half_day_charges}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <Form.Label>Hourly Charges:</Form.Label>
                    <p className="charges-text-holder">
                      { data?.service_charge?.hourly_basis_charges}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="col-lg-11 mx-auto mt-5">
            <div className="form-bg">
              <div className="row">
                {/* full / half day / hour */}
                {data?.service_type_id === 1 ? (
                  <>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <Form.Label>Whole day Charges:</Form.Label>
                        <p className="charges-text-holder">
                          {data?.service_charge?.full_day_charges} ({" "}
                          {data?.service_charge?.full_day_hours} Hours)
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <Form.Label>Half day Charges:</Form.Label>
                        <p className="charges-text-holder">
                          {data?.service_charge?.half_day_charges}({" "}
                          {data?.service_charge?.half_day_hours} Hours)
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <Form.Label>Hourly Charges:</Form.Label>
                        <p className="charges-text-holder">
                          {data?.service_charge?.hourly_basis_charges}
                        </p>
                      </div>
                    </div>{" "}
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <Form.Label>Start Time</Form.Label>
                        <p className="charges-text-holder">
                          {data?.service_charge?.full_d_start_time}
                        </p>
                      </div>
                    </div>{" "}
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <Form.Label>End Time</Form.Label>
                        <p className="charges-text-holder">
                          {data?.service_charge?.full_d_end_time}
                        </p>
                      </div>
                    </div>{" "}
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <Form.Label>Minimum Hours:</Form.Label>
                        <p className="charges-text-holder">
                          {data?.service_charge?.minimum_hours} Hours
                        </p>
                      </div>
                    </div>
                  </>
                ) : //full day
                  data?.service_type_id === 3 ? (
                    <>
                      <div className="col-lg-4 col-md-6">
                        <div className="form-group">
                          <Form.Label>Whole day Charges:</Form.Label>
                          <p className="charges-text-holder">
                            {data?.service_charge?.full_day_charges}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="form-group">
                          <Form.Label>Half day Charges:</Form.Label>
                          <p className="charges-text-holder">
                            {data?.service_charge?.half_day_charges}({" "}
                            {data?.service_charge?.half_day_hours} Hours)
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="form-group">
                          <Form.Label>Hourly Charges:</Form.Label>
                          <p className="charges-text-holder">
                            {data?.service_charge?.hourly_basis_charges}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="form-group">
                          <Form.Label>Minimum Hours:</Form.Label>
                          <p className="charges-text-holder">
                            {data?.service_charge?.minimum_hours} Hours
                          </p>
                        </div>
                      </div>
                    </>
                  ) : //hour
                    data?.service_type_id === 4 ? (
                      <>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <Form.Label>Hourly Charges:</Form.Label>
                            <p className="charges-text-holder">
                              {data?.service_charge?.hourly_basis_charges}
                            </p>
                          </div>
                        </div>{" "}
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <Form.Label>Start Time</Form.Label>
                            <p className="charges-text-holder">
                              {data?.service_charge?.full_d_start_time}
                            </p>
                          </div>
                        </div>{" "}
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <Form.Label>End Time</Form.Label>
                            <p className="charges-text-holder">
                              {data?.service_charge?.full_d_end_time}
                            </p>
                          </div>
                        </div>{" "}
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <Form.Label>Minimum Hours:</Form.Label>
                            <p className="charges-text-holder">
                              {data?.service_charge?.minimum_hours} Hours
                            </p>
                          </div>
                        </div>
                      </>
                    ) : //fix rate
                      data?.service_type_id === 5 ? (
                        <>
                          <div className="col-lg-4 col-md-6">
                            <div className="form-group">
                              <Form.Label>Fix Charges:</Form.Label>
                              <p className="charges-text-holder">
                                {data?.service_charge?.fix_amount}
                              </p>
                            </div>
                          </div>
                        </>
                      ) : //per piece
                        data?.service_type_id === 6 ? (
                          <>
                            <div className="col-lg-4 col-md-6">
                              <div className="form-group">
                                <Form.Label>Per Piece Rate:</Form.Label>
                                <p className="charges-text-holder">
                                  {data?.service_charge?.per_rate}
                                </p>
                              </div>
                            </div>
                          </>
                        ) : //per piece
                          data?.service_type_id === 7 ? (
                            <>
                              <div className="col-lg-4 col-md-6">
                                <div className="form-group">
                                  <Form.Label>Minimum Hours:</Form.Label>
                                  <p className="charges-text-holder">
                                    {data?.service_charge?.minimum_hours}
                                  </p>
                                </div>
                              </div>

                              <div className="col-lg-4 col-md-6">
                                <div className="form-group">
                                  <Form.Label>Minimum Kilometers:</Form.Label>
                                  <p className="charges-text-holder">
                                    {data?.service_charge?.minimum_kilometer}
                                  </p>
                                </div>
                              </div>
                            </>
                          ) : null}
              </div>
            </div>
          </div>

          <div className="col-lg-9 col-md-12 mx-auto ">
            <Form>
              <h6 className="estimatedh6">
                Estimated Booking Cost: ₹ {details?.total}
                {/* {totalCharge + appSetup?.platform_charges
                  // Number(
                  //   data?.studio_add_ons
                  //     ?.map((value) => {
                  //       return value?.rate;
                  //     })
                  //     .join(", ")
                  // )
                } */}
                /-
              </h6>

              <div className="form-bg formm11">
                <div className="form-group ">
                  <Form.Label>Enter Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    {...register("name", {
                      required: "Name required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.name,
                      "is-valid": getValues("name"),
                    })}
                    onKeyDown={(event) => {
                      if (!RegxExpression.name.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {errors?.name && (
                    <sup className="text-danger">{errors?.name?.message}</sup>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Enter Email*</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Enter Email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: RegxExpression.email,
                        message: "Invalid email address",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.email,
                      "is-valid": getValues("email"),
                    })}
                  />
                  {errors?.email && (
                    <sup className="text-danger">{errors?.email?.message}</sup>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Enter Contact Number*</Form.Label>
                  <Controller
                    name="contact_no"
                    control={control}
                    rules={{
                      required: "Contact Number is required",
                      minLength: {
                        value: 10,
                        message: "Number should be at least 10 characters",
                      },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        className={classNames("", {
                          "is-invalid": errors?.contact_no,
                          "is-valid": getValues("contact_no"),
                        })}
                        onChange={(value) => field.onChange(value)}
                        type="text"
                        placeholder="Enter Mobile Number"
                        onKeyDown={(event) => {
                          if (!RegxExpression.phone.test(event.key)) {
                            if (event.key !== "Backspace") {
                              event.preventDefault();
                            }
                          }
                        }}
                        maxLength={10}
                      />
                    )}
                  />
                  {errors?.contact_no && (
                    <sup className="text-danger">
                      {errors?.contact_no?.message}
                    </sup>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Enter Project Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    type="text"
                    name="name"
                    placeholder="Enter Description"
                    {...register("description", {
                      // required: "Description required",
                    })}
                  />
                </div>
              </div>

              <div className="form-bg addformm mt-3">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      Add Ons<span> (Optional)</span>{" "}
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="acc-opn mb-3">
                        <div className="add-one">
                          <h6 className="addh6">ADD-ONS</h6>
                          <Controller
                            name="add_on_id"
                            control={control}
                            defaultValue={[]}
                            render={({ field }) => (
                              <>
                                {data?.services_add_ons?.map((val) => (
                                  <Form.Check
                                    key={val?.add_on?.id} // Assuming `id` is the unique identifier
                                    type="checkbox"
                                    label={`${val.add_on.name} + ${val.rate}`}
                                    onChange={(e) => {
                                      setValue("calculation_status", false);
                                      setIsCalculationDone(false);

                                      handleCheckboxChange(
                                        val?.id,
                                        e.target.checked,
                                        val.rate
                                      );
                                    }}
                                    checked={field.value.includes(
                                      val?.id
                                    )}
                                  />
                                ))}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="acc-opn">
                        <div className="add-one">
                          <h6 className="addh6">ADDITIONAL SUPPORT</h6>
                          <Form>
                            <Controller
                              name="additional_support_id"
                              control={control}
                              defaultValue={[]} // Ensure default value is an empty array
                              render={({ field }) => (
                                <>
                                  {dataSupport?.map((val) => (
                                    <Form.Check
                                      key={val.id} // Assuming `id` is the unique identifier
                                      type="checkbox"
                                      label={`${val.name}`}
                                      onChange={(e) =>
                                        handleCheckboxChangeSupport(
                                          val.id,
                                          e.target.checked
                                        )
                                      }
                                      checked={field.value.includes(val.id)} // Ensure field.value is an array
                                    />
                                  ))}
                                </>
                              )}
                            />
                            <div className="form-group mt-5">
                              <Form.Label className="addlabhh">
                                Add Additional Support
                              </Form.Label>
                              {/* <Form.Control
                                as="textarea"
                                placeholder="Type here..."
                              /> */}
                              <Form.Control
                                as="textarea"
                                type="text"
                                name="name"
                                placeholder="Enter Description"
                                {...register("support_description", {})}
                              />
                            </div>

                            {/* calculation based on hour/full/half day */}

                            <div className="Bifurcation_charges_text">
                              {data?.service_type_id === 1 ||
                                data?.service_type_id === 3 ||
                                data?.service_type_id === 4 ? (
                                <>
                                  <div className="row justify-content-end">
                                    <div className="col-xl-5 col-lg-5  col-md-12 col-sm-12 col-12">
                                      <div className="heading-holder">
                                        <h3>Bifurcation Of Charges </h3>
                                      </div>

                                      {/* {useRoundedHours ===
                                          data?.service_charge?.half_day_hours && ( */}

                                      {/* ======================================================== */}

                                      <div className="Bifurcation_content-holder">
                                        <div className="text-holder">
                                          <h4>Days:-</h4>
                                          <span>{details?.days}</span>
                                        </div>
                                        <div className="text-holder">
                                          <h4>
                                            Full Day Charges x (
                                            {details?.charges?.full_h_c}):-
                                          </h4>
                                          <span>
                                            {" "}
                                            ₹ {details?.charges?.full_h_p}
                                          </span>
                                        </div>
                                        <div className="text-holder">
                                          <h4>
                                            {" "}
                                            Half Day Charges x (
                                            {details?.charges?.half_h_c}) :-
                                          </h4>
                                          <span>
                                            {/* ₹ {data?.service_charge?.half_day_charges} */}
                                            ₹ {details?.charges?.half_h_p}
                                          </span>
                                        </div>
                                        <div className="text-holder">
                                          <h4>
                                            {" "}
                                            Hourly Basis Charges x (
                                            {details?.charges?.min_h_c}) :-
                                          </h4>
                                          <span>
                                            {" "}
                                            ₹ {details?.charges?.min_h_p}
                                          </span>
                                        </div>

                                        <div className="text-holder">
                                          <h4>Add On Charges:-</h4>
                                          <span>
                                            ₹ {details?.add_one_price}
                                          </span>
                                        </div>

                                        <hr></hr>

                                        <div className="text-holder">
                                          <h4>Base Total:-</h4>
                                          <span>₹ {details?.base_price}</span>
                                        </div>

                                        <div className="text-holder">
                                          <h4>
                                            {" "}
                                            PlatFrom Charges(
                                            {details?.platform_charge}%)
                                          </h4>
                                          <span>
                                            + ₹{" "}
                                            {details?.platform_charge_toshow}
                                          </span>
                                        </div>

                                        <div className="text-holder">
                                          <h4> GST({details?.gst}%) :-</h4>
                                          <span>
                                            + ₹ {details?.gstchargestoshow}
                                          </span>
                                        </div>
                                        <hr></hr>
                                        <div className="text-holder">
                                          <h4>Total:-</h4>
                                          <span>₹ {details?.total}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : data?.service_type_id === 5 ? (
                                <>
                                  <>
                                    <div className="row justify-content-end">
                                      <div className="col-xl-5 col-lg-5  col-md-12 col-sm-12 col-12">
                                        <div className="heading-holder">
                                          <h3>Bifurcation Of Charges </h3>
                                        </div>

                                        <div className="Bifurcation_content-holder">
                                          <div className="text-holder">
                                            <h4>Days:-</h4>
                                            <span>{details?.days}</span>
                                          </div>

                                          <div className="text-holder">
                                            <h4>Add On Charges:-</h4>
                                            <span>
                                              ₹ {details?.add_one_price}
                                            </span>
                                          </div>

                                          <hr></hr>

                                          <div className="text-holder">
                                            <h4>Base Total:-</h4>
                                            <span>₹ {details?.base_price}</span>
                                          </div>

                                          <div className="text-holder">
                                            <h4>
                                              {" "}
                                              PlatFrom Charges(
                                              {details?.platform_charge}%)
                                            </h4>
                                            <span>
                                              + ₹{" "}
                                              {details?.platform_charge_toshow}
                                            </span>
                                          </div>

                                          <div className="text-holder">
                                            <h4> GST({details?.gst}%) :-</h4>
                                            <span>
                                              + ₹ {details?.gstchargestoshow}
                                            </span>
                                          </div>
                                          <hr></hr>
                                          <div className="text-holder">
                                            <h4>Total:-</h4>
                                            <span>₹ {details?.total}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                </>
                              ) : data?.service_type_id === 6 ? (
                                <>
                                  <div className="row justify-content-end">
                                    <div className="col-xl-5 col-lg-5  col-md-12 col-sm-12 col-12">
                                      <div className="heading-holder">
                                        <h3>Bifurcation Of Charges </h3>
                                      </div>

                                      <div className="Bifurcation_content-holder">
                                        <div className="text-holder">
                                          <h4>Days:-</h4>
                                          <span>{details?.days}</span>
                                        </div>
                                        <div className="text-holder">
                                          <h4>
                                            No. of Pieces x (
                                            {details?.no_of_pieces}):-
                                          </h4>
                                          <span>
                                            {" "}
                                            ₹ {details?.no_of_pieces}
                                          </span>
                                        </div>

                                        <div className="text-holder">
                                          <h4>Add On Charges:-</h4>
                                          <span>
                                            ₹ {details?.add_one_price}
                                          </span>
                                        </div>

                                        <hr></hr>

                                        <div className="text-holder">
                                          <h4>Base Total:-</h4>
                                          <span>₹ {details?.base_price}</span>
                                        </div>

                                        <div className="text-holder">
                                          <h4>
                                            {" "}
                                            PlatFrom Charges(
                                            {details?.platform_charge}%)
                                          </h4>
                                          <span>
                                            + ₹{" "}
                                            {details?.platform_charge_toshow}
                                          </span>
                                        </div>

                                        <div className="text-holder">
                                          <h4> GST({details?.gst}%) :-</h4>
                                          <span>
                                            + ₹ {details?.gstchargestoshow}
                                          </span>
                                        </div>
                                        <hr></hr>
                                        <div className="text-holder">
                                          <h4>Total:-</h4>
                                          <span>₹ {details?.total}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : data?.service_type_id === 7 ? (
                                <>
                                  <div className="row justify-content-end">
                                    <div className="col-xl-5 col-lg-5  col-md-12 col-sm-12 col-12">
                                      <div className="heading-holder">
                                        <h3>Bifurcation Of Charges </h3>
                                      </div>

                                      <div className="Bifurcation_content-holder">
                                        <div className="text-holder">
                                          <h4>Days:-</h4>
                                          <span>{details?.days}</span>
                                        </div>
                                        <div className="text-holder">
                                          <h4>
                                            No. of Kilometer x (
                                            {details?.no_of_kilometer}):-
                                          </h4>
                                          <span>
                                            {" "}
                                            ₹ {details?.no_of_kilometer}
                                          </span>
                                        </div>

                                        <div className="text-holder">
                                          <h4>Add On Charges:-</h4>
                                          <span>
                                            ₹ {details?.add_one_price}
                                          </span>
                                        </div>

                                        <hr></hr>

                                        <div className="text-holder">
                                          <h4>Base Total:-</h4>
                                          <span>₹ {details?.base_price}</span>
                                        </div>

                                        <div className="text-holder">
                                          <h4>
                                            {" "}
                                            PlatFrom Charges(
                                            {details?.platform_charge}%)
                                          </h4>
                                          <span>
                                            + ₹{" "}
                                            {details?.platform_charge_toshow}
                                          </span>
                                        </div>

                                        <div className="text-holder">
                                          <h4> GST({details?.gst}%) :-</h4>
                                          <span>
                                            + ₹ {details?.gstchargestoshow}
                                          </span>
                                        </div>
                                        <hr></hr>
                                        <div className="text-holder">
                                          <h4>Total:-</h4>
                                          <span>₹ {details?.total}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : null}

                              <div className="calculate-btn-holder">
                                {!isCalculationDone && ( // Conditionally render the button
                                  <button
                                    type="button"
                                    className="calculate-btn"
                                    disabled={isButtonDisabled}
                                    onClick={() => {
                                      console.log("sdasdasdadsasd");
                                      handleSubmit(onSubmitCalculation)();
                                      clearErrors("calculation_status");
                                    }}
                                  >
                                    Check Price
                                  </button>
                                )}

                                {errors.calculation_status && (
                                  <div className="text-danger">
                                    {errors.calculation_status.message}
                                  </div>
                                )}

                                <div className="icresvaliderrr ">
                                  <p>{calculationError}</p>
                                </div>
                              </div>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>

              {/* {isCalculationDone ? (
                <>
                  {userdata?.amount >= details?.total ? (
                    <div className="text-center mt-5">
                      <buttton
                        className="proceed-btn"
                        onClick={() => {
                          handleSubmit();
                          setModalWalleteShow(true);
                        }}
                      >
                        Open Wallet Model
                      </buttton>
                    </div>) :

                    (
                      <div className="text-center mt-5">
                        <buttton
                          className="proceed-btn"
                          onClick={() => {
                            handleSubmit(onSubmit)
                            setModalWalleteShow(true);
                          }}
                        >
                          Proceed to Pay
                        </buttton>
                      </div>
                    )
                  }
                </>
              ) : null} */}

              {isCalculationDone && (
                <div className="text-center mt-5">
                  <buttton
                    className="proceed-btn"
                    onClick={() => {
                      handleSubmit(onSubmit);
                      setModalWalleteShow(true);
                      setmodalCount((count) => count + 1);
                    }}
                  >
                    Proceed to Pay
                  </buttton>
                </div>
              )}


            </Form>
          </div>
        </div>
      </div>

      <Wallet_Payment_modal
        key={modalCount}
        setPaymentType={setPaymentType}
        set_advance_amount={set_advance_amount}
        set_payment_percentage_id={set_payment_percentage_id}
        handleSubmit={handleSubmit(onSubmit)}
        loading={loading}
        setLoading={setLoading}
        show={modalWalletShow}
        onHide={() => setModalWalleteShow(false)}
        total={details?.total}
        userdataAmount={userdata?.amount}
      />

      <Success_modal
        maintext={"Booking Successful"}
        smalltext={"Soon you will be notified by email & sms."}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Daily_form;
